var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgInvoicePaidV1 = function SvgInvoicePaidV1(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Invoice-Paid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.13,9.13V61.82a1.28,1.28,0,0,1-1.29,1.28H9.16a1.28,1.28,0,0,1-1.28-1.28c0-16.14,0-33.21,0-49.3V2.11A1.54,1.54,0,0,1,9.41.56H54.59a1.54,1.54,0,0,1,1.54,1.55Z",
    style: {
      fill: "#edfdfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,23.38c-5.32,0-10.65,0-16,0-.66,0-.95-.12-.9-.86a31.64,31.64,0,0,0,0-3.23c0-.62.19-.76.77-.76,5.18,0,10.35,0,15.52,0H47.82c1.21,0,1.07-.11,1.07,1.11,0,1,0,2,0,2.94,0,.64-.2.79-.81.79C42.72,23.37,37.35,23.38,32,23.38Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1,41.51a9.65,9.65,0,1,1-9.52-9.69A9.65,9.65,0,0,1,50.1,41.51Z",
    style: {
      fill: "#fbb03b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,27H47.23a5,5,0,0,1,.67,0,1.17,1.17,0,0,1,1,1.24,1.14,1.14,0,0,1-1,1.14,3,3,0,0,1-.6,0H16.7a3,3,0,0,1-.6,0,1.16,1.16,0,0,1-1-1.23,1.14,1.14,0,0,1,1-1.15,3.85,3.85,0,0,1,.68,0Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.45,10.1c0-1.13,0-2.26,0-3.39s.44-1.38,1.42-1.43c2-.11,3.71.32,4.9,2a4.6,4.6,0,0,1,.38,5,4.61,4.61,0,0,1-4.24,2.64c-2.32.08-2.46-.08-2.46-2.41Z",
    style: {
      fill: "#87c690"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.82,56H31.08c-1,0-1.48-.42-1.49-1.2s.51-1.21,1.47-1.21H48.61c1,0,1.48.42,1.49,1.2S49.59,56,48.63,56Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.53,10.08c0-1.11,0-2.21,0-3.32S18,5.29,19,5.28c.72,0,1.45,0,2.18,0a3.62,3.62,0,0,1,0,7.23,2.29,2.29,0,0,1-.37,0c-.72-.13-1,.14-.91.88.07,1-.4,1.51-1.15,1.53s-1.24-.54-1.24-1.54S17.53,11.18,17.53,10.08Z",
    style: {
      fill: "#87c690"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.19,13.16a4,4,0,0,1,0,.77,1.13,1.13,0,0,1-1,1A1,1,0,0,1,31,14.32c-.19-.62-.59-.62-1.08-.6a5.61,5.61,0,0,1-.82,0c-.4,0-.69,0-.85.5A1,1,0,0,1,27,14.9a1.13,1.13,0,0,1-1-1.15,5.2,5.2,0,0,1,.33-2.36C27,9.72,27.7,8,28.36,6.3c.23-.59.57-1,1.25-1s1,.46,1.22,1q1,2.63,2.1,5.24A3,3,0,0,1,33.19,13.16Z",
    style: {
      fill: "#87c690"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.72,34.24H16.53c-.9,0-1.41-.44-1.41-1.19s.5-1.21,1.39-1.22H27c.9,0,1.41.44,1.41,1.2s-.5,1.21-1.39,1.21Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75,36.65H27c.91,0,1.41.42,1.43,1.17s-.49,1.24-1.44,1.24H16.55c-.91,0-1.42-.42-1.43-1.17s.49-1.24,1.44-1.24Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.74,43.89H16.55c-.91,0-1.42-.42-1.43-1.18s.49-1.23,1.44-1.23H27c.91,0,1.42.41,1.43,1.17s-.49,1.23-1.44,1.24Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.62,10c0-1.13,0-2.26,0-3.39a1.2,1.2,0,0,1,1.18-1.35A1.19,1.19,0,0,1,38,6.61c0,2.33,0,4.67,0,7a1.2,1.2,0,0,1-1.22,1.32,1.21,1.21,0,0,1-1.18-1.37C35.61,12.39,35.62,11.21,35.62,10Z",
    style: {
      fill: "#87c690"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75,48.71h-.61c-.33-.2-.72,0-1-.15a6.45,6.45,0,0,1-4.78-3.23,7.36,7.36,0,0,1-1-2.5c-.19-.33,0-.72-.15-1V41c.19-.28,0-.62.15-.9a7.49,7.49,0,0,1,2.21-4,6.85,6.85,0,0,1,3.52-1.7c.33-.2.72,0,1-.15h.61c.33.2.72-.05,1,.15a8,8,0,0,1,4,2.24,6.8,6.8,0,0,1,1.76,3.49c.19.33,0,.72.14,1.05v.61c-.19.33,0,.72-.14,1a7,7,0,0,1-5.74,5.73C41.47,48.76,41.08,48.51,40.75,48.71Z",
    style: {
      fill: "#f5d79b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.14,34.24c-.31.28-.7.09-1,.15C39.41,34.09,39.79,34.29,40.14,34.24Z",
    style: {
      fill: "#facd5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8,34.39c-.34-.06-.73.13-1-.15C41.1,34.29,41.49,34.09,41.8,34.39Z",
    style: {
      fill: "#facc5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.68,41.17c-.28-.32-.09-.7-.14-1.05C47.83,40.43,47.63,40.82,47.68,41.17Z",
    style: {
      fill: "#facd58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.21,41.78c.29.32.1.7.15,1C33.07,42.51,33.27,42.13,33.21,41.78Z",
    style: {
      fill: "#f9cb5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.54,42.83c.05-.35-.14-.73.14-1C47.63,42.13,47.83,42.51,47.54,42.83Z",
    style: {
      fill: "#facc56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.09,48.56c.35.06.74-.13,1,.15C39.79,48.65,39.41,48.85,39.09,48.56Z",
    style: {
      fill: "#facc5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75,48.71c.32-.29.7-.09,1-.15C41.49,48.85,41.1,48.66,40.75,48.71Z",
    style: {
      fill: "#facc56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.36,40.12c0,.3.12.64-.15.9C33.26,40.72,33.09,40.38,33.36,40.12Z",
    style: {
      fill: "#f9c95f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.86,10.12c0-.65,0-1.31,0-2,0-.44.17-.5.55-.41a2.42,2.42,0,0,1,0,4.71c-.45.11-.59,0-.57-.46C42.88,11.37,42.86,10.74,42.86,10.12Z",
    style: {
      fill: "#edfdfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.68,10.11c-.66.18-.83-.2-.74-.85,0-.17,0-.35,0-.52.07-.34-.23-.89.2-1a2,2,0,0,1,1.73.2,1.14,1.14,0,0,1,.46,1.19C22.2,9.8,21.7,10.1,20.68,10.11Z",
    style: {
      fill: "#edfdfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,11.3l.58-1.45c.33.49.64,1,.53,1.35S29.43,11.28,29,11.3Z",
    style: {
      fill: "#edfdfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.08,39.6c0,.55.42.93,1.17.94a2.38,2.38,0,0,1,1.08,4.55c-.32.14-.49.26-.47.63a.59.59,0,0,1-.63.69.63.63,0,0,1-.69-.7.61.61,0,0,0-.43-.69,1.94,1.94,0,0,1-1-1.06.61.61,0,0,1,.24-.9.62.62,0,0,1,.95.26A1,1,0,0,0,40.4,44a1.16,1.16,0,0,0,1-1.09,1.08,1.08,0,0,0-1.14-1A2.36,2.36,0,0,1,38,40.54a2.31,2.31,0,0,1,1-3.13c.34-.17.58-.32.56-.77a.62.62,0,0,1,.66-.63.61.61,0,0,1,.65.63.74.74,0,0,0,.56.83,2,2,0,0,1,.9,1,.64.64,0,0,1-.31,1c-.38.2-.66,0-.87-.32a1,1,0,0,0-1.22-.6A1,1,0,0,0,39.08,39.6Z",
    style: {
      fill: "#fbb03b"
    }
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvoicePaidV1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Invoice_Paid_v1.6f343759.svg";
export { ForwardRef as ReactComponent };